module.exports = "/_next/static/images/e32c030446fc0114c0ef569395d92308-card-background-right-lg.jpg";